import { __awaiter } from "tslib";
import { Instruction } from '../game/Instruction';
import { castToString } from '../utils/cast-to-string';
export default function handleApiPrompt(world, type, data) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (type) {
            case 'enqueue':
                yield handleEnqueue(world, data);
                return {};
            case 'getReady':
                const robots = Object.values(world.robots);
                return {
                    robots: robots.filter(r => !r.isActive()).map(r => r.name)
                };
        }
    });
}
/**
 * Enqueue a robot instruction.
 */
function handleEnqueue(world, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const instruction = Instruction.parse(data.command, data.args);
        const target = ensureTarget(world, data);
        target.enqueue(instruction);
    });
}
function ensureTarget(world, data) {
    const name = castToString(data.name, '<unspecified>');
    if (!world.robots[name]) {
        throw new Error('Unknown robot: ' + name);
    }
    return world.robots[name];
}
